import { createStyles, makeStyles } from '@material-ui/core';
import { ExtendedTheme } from '../theme';

const useStyles = makeStyles(({ breakpoints, container, colors }: ExtendedTheme) => createStyles({
  container: {
    justifyContent: 'center',
    minHeight: 'calc(100vh - 66px)',
    [breakpoints.down('xs')]: {
      minHeight: 'calc(100vh - 58px)',
    },
  },
  errorPageContent: {
    width: '100%',
    flexGrow: 1,
  },
  content: {
    maxWidth: container,
    width: '100%',
    flexGrow: 1,
    padding: '0 8px',
  },
  dashboardCheckoutTheme: {
    background: colors.backgroundColor,

    [breakpoints.down(650)]: {
      background: '#FFF',
    },
  },
}), { name: 'DashboardLayout' });

export default useStyles;
